import SmallSelect from './SmallSelect';

export default SmallSelect;
